import { Helpers } from 'Helpers/helpers';
import * as balanceText from 'Lib/balanceText.js';

// @ts-ignore
let module: any = {};

//HERE WERE USING THE PAGINATION HELPER TO BUILD THE PAGINATION
module.setupPagination = (target, type, page, pagecount?) => {
    target.empty();
    pagecount =
        pagecount == null || pagecount == 'undefined' || pagecount == ''
            ? $(`#js-results-${type} #js-counts`).data('pagecount')
            : pagecount;
    let paginationArray = Helpers.BuildPaginationArray(page, pagecount);
    let paginationArrayLength = paginationArray.length;

    for (let i = 0; i < paginationArrayLength; i++) {
        let isActive;
        paginationArray[i].active ? (isActive = 'active') : (isActive = '');
        if (paginationArray[i].page == null) {
            $(`<li>${paginationArray[i].label}</li>`).appendTo(target);
        } else {
            $(
                `<li class="${isActive}"><a href="#" class="js-page-number" data-content-type="${type}" data-page="${paginationArray[i].page}" data-pagetotal="${pagecount}">${paginationArray[i].label}</a></li>`
            ).appendTo(target);
        }
    }
};

//FUNCTION TO GET PARAMETER BY NAME - (this is old could rewrite this for with urlParams)
module.getParameterByName = (name, url?) => {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

module.setupViewingResultsCount = (activeLink, resultsLength) => {
    let activePageNumber = activeLink.data('page') + 1 || 1;
    let numResults = resultsLength.length;
    let $pageBegin = $('.js-page-begin');
    let $pageEnd = $('.js-page-end');
    let pageEndNumber;
    let pageStartNumber;

    if (resultsLength.length < 20) {
        pageStartNumber = activeLink.data('page') * 20 + 1 || 1;
        pageEndNumber = pageStartNumber + (numResults - 1);
    } else {
        pageEndNumber = activePageNumber * numResults;
        pageStartNumber = pageEndNumber - (numResults - 1);
    }

    isNaN(pageStartNumber)
        ? $pageBegin.text('0')
        : $pageBegin.text(pageStartNumber);
    isNaN(pageEndNumber) ? $pageEnd.text('0') : $pageEnd.text(pageEndNumber);
};

module.setupSearch = function () {
    let $searchQuery = $('#FilterCriteria_Query');
    let url = $searchQuery.data('url');
    let $form = $('#fSearchResults');
    let tabValue = module.getParameterByName('FilterCriteria.Tab');
    let $paginationList = $('.js-pagination-list');
    let typeOfContent = $paginationList.data('content-type');
    let $loadIndicator = $('.js-load-indicator');
    let $loadIndicatorCover = $('.js-load-indicator-cover');
    //buildPaginationArray();'

    if (tabValue !== null) {
        $('.js-tabs .js-tab').removeClass('state-selected');
        $('#toggle-' + tabValue).addClass('state-selected');

        $('#product, #page, #workbench').removeClass('state-active');
        $('.js-tab-contents .js-tab-' + tabValue).addClass('state-active');
    }

    module.setupPagination($paginationList, typeOfContent, 0);

    $('body').on('change', '.js-search-filter', function (e) {
        let $checkbox = $(this);
        let contentType = $checkbox.data('contenttype');

        //setup the load indicator to run
        $loadIndicatorCover.removeClass('state-hidden');
        $loadIndicatorCover.addClass('state-visible');
        $loadIndicator.addClass('state-visible');

        // Set the content tab that is being updated and reset page number
        $('#FilterCriteria_Tab').val(contentType);
        $('#FilterCriteria_Page').val(0);

        // Refresh the contents of this tab
        $('#js-results-' + contentType).load(
            url,
            $form.serialize(),
            function (data) {
                // Update the page count in the header and on Load More link
                let $span = $('<div>' + data + '</div>').find('#js-counts');
                let $resultLi = $('<div>' + data + '</div>').find(
                    '.js-search-results-list > li'
                );

                $('.js-results-count-' + contentType).text(
                    $span.data('totalrecords')
                );

                module.setupPagination($paginationList, contentType, 0);

                setTimeout(function () {
                    let $pagingLink = $(
                        '.js-pagination-list li.active .js-page-number'
                    );
                    module.setupViewingResultsCount($pagingLink, $resultLi);
                    $loadIndicatorCover.removeClass('state-visible');
                    $loadIndicatorCover.addClass('state-hidden');
                    $loadIndicator.removeClass('state-visible');
                    balanceText('.balance-text');
                }, 200);
            }
        );
    });

    $('body').on('click', '.js-page-number', function (e) {
        $loadIndicatorCover.removeClass('state-hidden');
        $loadIndicatorCover.addClass('state-visible');
        $loadIndicator.addClass('state-visible');
        let $pagingLink = $(e.target);
        let contentType = $(this)
            .closest('.js-pagination-list')
            .data('content-type');
        let page = $pagingLink.data('page');
        let resultsContainer = $('#js-results-' + contentType);

        // Set the content tab that is being updated and update page number
        $('#FilterCriteria_Tab').val(contentType);
        $('#FilterCriteria_Page').val(page);

        // Append results to list
        resultsContainer.empty();
        resultsContainer.load(url, $form.serialize(), function (data) {
            resultsContainer.html(data);
            let $span = resultsContainer.find('#js-counts');
            let $resultLi = resultsContainer.find(
                '.js-search-results-list > li'
            );

            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });

            module.setupPagination(
                $paginationList,
                contentType,
                page,
                $span.data('pagecount')
            );

            setTimeout(function () {
                module.setupViewingResultsCount($pagingLink, $resultLi);
                $loadIndicatorCover.removeClass('state-visible');
                $loadIndicatorCover.addClass('state-hidden');
                $loadIndicator.removeClass('state-visible');
                balanceText('.balance-text');
            }, 200);
        });

        e.preventDefault();
    });

    $('.js-tab').on('click', function () {
        module.setupPagination(
            $paginationList,
            $(this).data('target').split('#')[1],
            0,
            $($(this).data('target')).find('#js-counts').data('pagecount')
        );

        setTimeout(function () {
            let $pagingLink = $(
                '.js-pagination-list li.active .js-page-number'
            );
            let $resultLi = $('.js-search-results-list:visible > li');

            module.setupViewingResultsCount($pagingLink, $resultLi);
            balanceText('.balance-text');
        }, 200);
    });

    //make sure at least one tab is set
    if (
        !$('.js-tab.state-selected').length &&
        !$('.tab-list__tab:first-child').find('.js-tab.state-active').length
    ) {
        let firstTab = $('.tab-list__tab:first-child').find('.js-tab');
        firstTab.addClass('state-selected');
        $(firstTab.attr('data-target')).addClass('state-active');
        firstTab.trigger('click');
    } else if ($('.js-tab.state-selected').length) {
        let selectedTab = $('.js-tab.state-selected');
        selectedTab.trigger('click');
        $(selectedTab.attr('data-target')).addClass('state-active');
    }

    $('.js-search-query').focus();
};

module.init = function () {
    module.setupSearch();
};

document.addEventListener('DOMContentLoaded', () => {
    module.init();
});
